<div class="heading-container" [style.textAlign]="hAlign">

  @if (titles.length > 0) {
    @for (title of titles; track trackByIndex($index, title)) {
      <div>
        <app-colorized-text [matTooltip]="headTooltip || null"
          [ngStyle]="{'font-weight': titleFontWeight}"
          [textColor]="titleColor">
          {{ title }}
        </app-colorized-text>
      </div>
    }
  }

  @if (subtitles.length > 0) {
    @for (subtitle of subtitles; track trackByIndex($index, subtitle)) {
      <div>
        <app-colorized-text [matTooltip]="subTooltip || null" [textColor]="subtitleColor" align="center">
          {{ subtitle }}
        </app-colorized-text>
      </div>
    }
  }

</div>
